import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { makeApi } from '@/api'
import { ApiContext, makeQueryClient } from '@/api/hooks'
import { applyTheme, readChoice } from '@/lib/theme'
import { router } from './router'
import './index.css'

// Follow the system's theme while no other is chosen, on every view.
window.matchMedia?.('(prefers-color-scheme: dark)').addEventListener('change', () => {
  if (readChoice() === 'system') applyTheme('system')
})

const client = makeQueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApiContext.Provider value={makeApi()}>
      <QueryClientProvider client={client}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ApiContext.Provider>
  </StrictMode>,
)
